export default {
  attachments: [],
  attachment: undefined,
};
